import { Text, TextInput } from '@mantine/core';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const ContactCard: React.FC = () => {
  const form = useEmployeeFormContext();

  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Kontaktní údaje
      </Text>

      <TextInput
        required
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="telefon"
        label="Telefon"
        {...form.getInputProps('phone')}
      />

      <TextInput
        required
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="e-mail"
        label="E-mail"
        {...form.getInputProps('email')}
      />
    </div>
  );
};
